import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { AppComponent } from 'src/app/app.component';
import { UserData } from 'src/app/models/user.model';
import { ChatService, Message } from 'src/app/services/chat.service';

@Component({
  selector: 'app-chat-window',
  templateUrl: './chat-window.component.html',
  
  styleUrls: ['./chat-window.component.css']
})
export class ChatWindowComponent implements OnInit {
  @Input() selectedUser: UserData;
  messages: Message[] = [];
  newMessage: string = '';
  currentUserId: string; //L'ID de l'utilisateur connecté (à initialiser avec votre logique d'authentification)


  constructor(private chatService: ChatService) { }

  ngOnInit(): void {
    // Charger les messages de la discussion avec l'utilisateur sélectionné
    /*this.chatService.getMessages(this.currentUserId, this.selectedUser.uid).then((messages) => {
      this.messages = messages;
    }); */
  }

  sendMessage(): void {
    if (this.newMessage.trim()) {
      this.chatService.sendMessage(this.currentUserId, this.selectedUser.uid, this.newMessage);
      this.newMessage = '';
    }
  }

  closeChatWindow(){
    this.chatService.closeChatWindow(this.selectedUser.uid);
  }

  /**sendMessage(currentUserId: string, selectedUserId: string, text: string): void {
    alert(currentUserId);
    alert( selectedUserId);
    alert( text);
    this.chatService.sendMessage(currentUserId, selectedUserId, text);
  } */
}
